'use strict'
export default {
  name: 'gec-footer',
  data () {
    return {
      logo: false,
      currentYear: this.getCurrentYear()
    }
  },
  mounted () {
    if (this.$route.query.logo === 'yes') {
      this.logo = true
    }
  },
  methods: {
    jumpToWeb (url) {
      window.location.href = url
    },
    getCurrentYear () {
      const MY_DATE = new Date()
      const CURRENT_YEAR = MY_DATE.getFullYear()
      return CURRENT_YEAR
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/gecFooter/gec-footer.js